module.exports = __webpack_public_path__ + "img/12.6aeaa3a5.png";